<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit User
            </h2>
        </template>
        <user-form v-bind="$props" :action="route('users.update', user.id)" button="Update"></user-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import UserForm from './Form';

    export default {
        components: {
            AppLayout,
            UserForm,
        },

        props: ['user', 'partners', 'roles'],
    }
</script>
